import { Component, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { CommonService } from '../../../../service/Security/common.service';
import { UntypedFormGroup, FormControl, Validators, UntypedFormBuilder } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MainContainerService } from 'src/app/service/main-container.service';
import { ToastService } from 'src/app/service/toast.service';
import { Appointment } from 'src/app/model/Security/Appointment';
import { MaxAppointmentNo, Company, Employee } from 'src/app/model/Security/common';
import { Department } from 'src/app/model/AssetSetUp/department';
import { AppointmentService } from 'src/app/service/Security/appointment.service';
import { Constant } from 'src/app/common/constant';
import { LocalStorageService } from 'src/app/common/LocalStorageService';


@Component({
  selector: 'app-appointment',
  templateUrl: './appointment.component.html',
  styleUrls: ['./appointment.component.css']
})
export class AppointmentComponent implements OnInit {

  newForm: UntypedFormGroup;
  editForm: UntypedFormGroup;
  tabGroup: { selectedIndex: any; };

  appointment: Appointment = new Appointment();
  editAppointment: Appointment = new Appointment();

  maxappointnos: Observable<MaxAppointmentNo[]>;
  companies: Observable<Company[]>;

  employees: Observable<Employee[]>;
  departments: Observable<Department[]>;


  public appointmentTypes: string[];
  public appointmentfixedbyes: string[];
  date: Date;
  data = "";
  defaultCompany = "";
  http: any;
  defaultAppointType = "";
  defaultappointmentFixedBy = "";
  private editmode: boolean = false
  apiFactory: any;

  testId: Number;
  result: string;

  editing: boolean = false;
  appointmentSubcription: Subscription;
  appointmentList: Appointment[];

  defEditDepartment: string;

  viewtableColumns: string[] = ['appointment_type', 'visitor_name', 'visitor_company', 'appointment_fixed_by', 'whomto_meet', 'purpose', 'schedule_date_from', 'time'];
  deletetableColumns: string[] = ['ref_no', 'appointment_type', 'visitor_name', 'visitor_company', 'appointment_fixed_by', 'whomto_meet', 'purpose', 'schedule_date_from', 'time', 'cancel'];

  viewDataAvail: boolean;

  noOfDaysAllowed: any;
  ActiveTab: number;
  maxAllowDate: Date = new Date();
  constructor(
    private toastService: ToastService,
    private mainContainerService: MainContainerService,
    private fb: UntypedFormBuilder,
    private appointmentService: AppointmentService,
    private commonService: CommonService,
    private constant: Constant,
    public persistenceService: LocalStorageService
    ) {
    this.newForm = this.fb.group({
      ref_no: ['', Validators.required],
      company_id: ['', Validators.required],
      booked_on_date: ['', Validators.required],
      booked_at_time: ['', Validators.required],
      visitor_name: ['', Validators.required],
      visitor_company: ['', Validators.required],
      address: ['', Validators.required],
      visitor_mobile_no: ['', Validators.required],
      country: ['', Validators.required],
      state: ['', Validators.required],
      city: ['', Validators.required],
      pin: ['', Validators.required],
      appointment_fixed_by: ['', Validators.required],
      whomto_meet: ['', Validators.required],
      department_id: ['', Validators.required],
      appointment_type: ['', Validators.required],
      purpose: ['', Validators.required],
      schedule_date_from: ['', Validators.required],
      schedule_time_from: ['', Validators.required],
      schedule_date_to: ['', Validators.required],
      schedule_time_to: ['', Validators.required],
    });
    this.editForm = this.fb.group({
      ref_no: ['', Validators.required],
      company_id: ['', Validators.required],
      booked_on_date: ['', Validators.required],
      booked_at_time: ['', Validators.required],
      visitor_name: ['', Validators.required],
      visitor_company: ['', Validators.required],
      address: ['', Validators.required],
      visitor_mobile_no: ['', Validators.required],
      country: ['', Validators.required],
      state: ['', Validators.required],
      city: ['', Validators.required],
      pin: ['', Validators.required],
      appointment_fixed_by: ['', Validators.required],
      whomto_meet: ['', Validators.required],
      department_id: ['', Validators.required],
      appointment_type: ['', Validators.required],
      purpose: ['', Validators.required],
      schedule_date_from: ['', Validators.required],
      schedule_time_from: ['', Validators.required],
      schedule_date_to: ['', Validators.required],
      schedule_time_to: ['', Validators.required],
    });

  }
  ngOnInit() {

    this.companies = this.commonService.getCompanyList();
    this.departments = this.commonService.getDepartmentList();

    // this.employees = this.commonService.getEmployeeList();
    this.maxappointnos = this.commonService.getMaxAppointmentNo();
    this.appointment.booked_on_date = this.commonService.getCurrentDate();
    this.appointment.booked_at_time = this.commonService.getCurrentTime();
    this.appointmentTypes = this.constant.appointmentType;
    this.appointmentfixedbyes = this.constant.appointmentFixedBy;
    this.appointment.schedule_date_from = this.commonService.getCurrentDate();
    this.appointment.schedule_date_to = this.commonService.getCurrentDate();
    this.appointment.company_id = this.constant.defaultCompany;
    this.defaultCompany = this.constant.defaultCompanyName;
    this.appointment.appointment_fixed_by = "Self";
    this.appointment.appointment_type = "Official";
    this.getAppointmentList();
  }
  saveAppointment(event: any) {
    this.appointment.ref_no = event.target.ref_no.value;
    this.appointmentService.createAppointment(this.appointment)
      .subscribe(data => console.log(data), error => console.log(error));
    this.toastService.showSuccessToast(this.constant.appointmentSaveToast);
    this.appointment = new Appointment();
    this.ngOnInit();
  }
  saveEditAppointment(event: any) {
    this.appointmentService.editAppointment(this.editAppointment)
      .subscribe(data => console.log(data), error => console.log(error));
    this.toastService.showSuccessToast(this.constant.appointmentEditToast);
  }
  onEditDepartmentSelect(event: any) {
    this.editAppointment.department_id = event;
  }
  getAppointmentList() {
    this.appointmentSubcription = this.commonService.getAppointmentList().subscribe((data) => {
      let result: Appointment[] = data;
      this.appointmentList = result;
      if (this.appointmentList.length === 0) {
        this.viewDataAvail = false;
      }
      else
        this.viewDataAvail = true;
    });
  }
  tabClicked(event: any) {
    if (event.index == 1 || event.index == 2 || event.index == 3) {
      this.getAppointmentList();
    }
    else {
      this.ngOnInit();
      this.editmode = false;
    }
  }

  onEditAppointmentSelect(id: any) {
    this.commonService.getAppointmentListById(id)
      .subscribe(data => {
        console.log(data);
        this.editmode = true;
        this.viewDataAvail = true;
        this.editAppointment = data;
        this.defEditDepartment = this.editAppointment.department_id.toString();
      }, error => console.log(error));
  }

  onCancelAppointmentClick(id: any) {
    this.appointmentSubcription = this.commonService.deleteAppointments(id).subscribe((data) => {
    });
    this.getAppointmentList();
    this.ngOnInit();
    this.toastService.showSuccessToast(this.constant.cancelSuccessfullyToast);
  }
  addEventScheduleDateFrom(event: MatDatepickerInputEvent<Date>) {
    if (this.editmode == true)
      this.editAppointment.schedule_date_from = this.commonService.changeDateFormat(event.value);
    else
      this.appointment.schedule_date_from = this.commonService.changeDateFormat(event.value);
  }
  addEventScheduleDateTo(event: MatDatepickerInputEvent<Date>) {
    if (this.editmode == true)
      this.editAppointment.schedule_date_to = this.commonService.changeDateFormat(event.value);
    else
      this.appointment.schedule_date_to = this.commonService.changeDateFormat(event.value);
  }
  addEventScheduleTimeFrom(event: string) {
    if (this.editmode == true)
      this.editAppointment.schedule_time_from = event;
    else
      this.appointment.schedule_time_from = event;
  }
  addEventScheduleTimeTo(event: string) {
    if (this.editmode == true)
      this.editAppointment.schedule_time_to = event;
    else
      this.appointment.schedule_time_to = event;
  }

}
